<template>
  <div>
    <v-card flat class="mt-5">
      <h5>Handledarutbildningar</h5>
      <v-data-table
        :headers="[
          {text: 'UTBILDNING', sortable: false, filterable: false, value: 'displayType', width: '340'},
          {text: 'GODK. / TILLAGD', sortable: false, filterable: false, value: 'issuedOn', width: '120'},
          {text: 'UTFÄRDARE', filterable: false, value: 'issuedBy', width: '170'},
          {text: 'STATUS', sortable: false, filterable: false, value: 'status', width: '160'},
          {text: '', filterable: false, value: 'actions'}
        ]"
        :items="items"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        hide-default-footer
        item-key="id"
      >

        <template slot="item.issuedOn" slot-scope="props">
          {{ props.item.issuedOn | date }}
        </template>

        <template slot="item.actions" slot-scope="props">
          <span :data-cy-id="props.item.id"></span>
          <div class="d-flex justify-end">
            <v-btn
              class="ml-4"
              data-cy="delete-card"
              color="secondary"
              @click="
                modalMode = 'edit'
                diverseQualification = props.item
                showModal = true
              "
            >
              Visa / Ändra
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <v-dialog v-model="showModal" :max-width="'720px'">
        <Dialog
          :diverseQualification="diverseQualification"
          :modalMode="modalMode"
          :showModal="showModal"

          @create="
            modalMode = 'create'
            showModal = false
            createDC(...arguments)
          "
          @delete="
            modalMode = 'create'
            showModal = false
            deleteDC(...arguments)
          "
          @close="
            modalMode = 'create'
            showModal = false
            fetchDiverseQualifications()
          "
        />
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import API from '@/services/api'
import get from 'lodash/get'
import findIndex from 'lodash/findIndex'
import {UserRules} from '@/components/mixins'
import Dialog from '@/components/person/DiverseQualifications/Modal'
import {pageSize} from '@/store/constants'

// @group Person
// PersonMachinaCard component
export default {
  name: 'List',
  
  mixins: [UserRules],

  props: {
    initialMode: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    showModal: false,
    modalMode: '',
    diverseQualification: {},
    items: [],
    itemsPerPage: pageSize
  }),
  
  components: {
    Dialog
  },
  
  watch: {
    initialMode(newValue) {
      if (newValue === 'MKF handledarutbildning') {
        this.modalMode = 'create'
        this.diverseQualification = {issuedOn: this.$options.filters.date(new Date())}
        this.showModal = true
      }
    }
  },

  created() {
    this.fetchDiverseQualifications()
  },
  
  computed: {
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('app', ['isLoading'])
  },
  methods: {
    /**
     * @vuese
     * Used to fetch data
     * @arg The argument is integer values representing person id
     */
    fetchDiverseQualifications() {
      this.modalMode = 'create'
      this.items = []
      API.getPersonDiverseQualifications(this.selectedPerson.id)
        .then(res => {
          if (! res.data && res.data.diversequalifications) {
            return
          }
          this.items = res.data.diversequalifications.map(q => {
            return {
              id: q.id,
              issuedOn: q.issuedOn,
              displayType: get(q,'diversequalificationtype.name', '-'),
              diverseQualificationType: get(q,'diversequalificationtype.type', '-'),
              issuedBy: [get(q,'issuedBy.firstName', '-'),get(q,'issuedBy.lastName', '-')].join(' '),
              status: '-'
            }
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },

    async deleteDC(val) {
      console.log(val)
      if (!(val && val.id)) {
        return
      }

      const res = await this.$dialog.confirm({
        text: 'Detta går inte att ångra.',
        title: 'RADERA MKF HANDLEDARUTB.?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if (res !== true) return

      API.deleteDiverseQualifications(val.id).then(res => {
        this.diverseQualification = {}
        this.items.splice(findIndex(this.items, ['id', val.id]), 1)
      })
    },

    createDC(val) {
      if (!(val && val.issuedOn && val.diverseQualificationType)) {
        return
      }

      API.createDiverseQualifications({
        data: {
          issuedOn: val.issuedOn,
          diverseQualificationType: val.diverseQualificationType,
          regionId: null,
          personId: this.selectedPerson.id,
        }
      }).then(res => {
        this.diverseQualification = {}
        this.fetchDiverseQualifications()
      })
    }
  }
}
</script>

<style>
</style>
